import React from "react";
import ReactDOM from "react-dom";
import App from "./AppLoad";

import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light.css";
import "tippy.js/animations/shift-away-subtle.css";
import reportWebVitals from "./reportWebVitals";
import { HashRouter } from "react-router-dom";
import { Provider } from "react-redux";
import Amplify from "aws-amplify";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import store from "./redux/redux_store/store";
import config from "./aws-exports";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();
let persistor = persistStore(store);
Amplify.configure(config);

if (window.location.hostname.replace("www.", "") === "www.ondc.academy") {
  document.title = "Welcome to ONDC Academy";
}

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <HashRouter>
        <App />
        </HashRouter>
      </PersistGate>
    </Provider>
    {/* <ReactQueryDevtools /> */}
  </QueryClientProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
